import React from 'react';
import {
  Button,
  Checkbox,
  Container,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import ReactTable from 'react-table';
import ActionButton from '../../../components/ActionButton';
import OneLineTextInputComponent from '../manualecomponents/components/OneLineTextInputComponent';
import MultilineTextInputComponent from '../manualecomponents/components/MultilineTextInputComponent';
import FileUploader from '../manualecomponents/dettaglio_procedura/FileUploader.js';
import {
  getCategorieSchede,
  getSchedeTramiteId,
  putModificaScheda,
  uploadSchedaImage,
} from '../../../utils/api/schede_api';
import {
  getAttrezzatureWithOnlyManualeId,
  getLocaliManuale,
  getTipologiaStrumentazione,
} from '../../../utils/api/locali_e_attrezzature_api';
import { getReparti } from '../../../utils/api/reparti';
import { DeleteForever, Edit } from '@material-ui/icons';
import ModalSelezioneAssociazioneScheda from './ModalSelezioneAssociazioneScheda';
import ModalSelezioneOrarioScheda from './ModalSelezioneOrarioScheda';
import IndietroButtonColorFul from '../../../components/IndietroButtonColorful';
import SpinnerComponent from '../../../components/SpinnerComponent';
import ModalAggiuntaValori from './ModalAggiuntaValori';
import AttachmentList from '../components/AttachmentList.js';
import PropTypes from 'prop-types';
import {
  getPDFForParagrafo,
  postAggiuntaPDFForParagrafo,
} from '../../../utils/api/paragrafi_api.js';
import { reportApiError, reportError } from '../../../utils/reportApiError';
import { etichettaCadenza } from '../../../utils/constants';

const styles = (theme) => ({
  mainContainer: {
    color: theme.palette.text.primary,
    padding: theme.spacing(4, 3),
    minHeight: '90vh',
    backgroundColor: theme.palette.background.default,
  },
  typo: {
    fontWeight: 700,
    margin: 0,
  },
  uploadWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  uploadContainer: {
    backgroundColor: '#f9f9f9',
    padding: theme.spacing(0, 2),
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '470px',
    width: '100%',
  },
  tableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  addButtonWrapper: {
    display: 'none',
  },
  pageShell: {
    maxWidth: 1480,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  pageHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    textAlign: 'left',
  },
  pageSubtitle: {
    color: theme.palette.text.secondary,
    maxWidth: 780,
    lineHeight: 1.6,
  },
  panelCard: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid rgba(15, 23, 42, 0.08)',
    borderRadius: 20,
    boxShadow: '0 12px 32px rgba(15, 23, 42, 0.08)',
    padding: theme.spacing(3),
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  sectionHeading: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  sectionDescription: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  contentContainer: {
    padding: 0,
    margin: 0,
    maxWidth: 'none',
  },
  tableSurface: {
    width: '100%',
    overflowX: 'auto',
    border: '1px solid rgba(15, 23, 42, 0.08)',
    borderRadius: 16,
    padding: theme.spacing(1.5),
    backgroundColor: 'rgba(15, 23, 42, 0.02)',
    boxSizing: 'border-box',
  },
  secondaryActionButton: {
    borderRadius: 12,
    padding: theme.spacing(1.25, 1.75),
    textTransform: 'none',
    fontWeight: 600,
  },
  footerBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    border: '1px solid rgba(15, 23, 42, 0.08)',
    borderRadius: 20,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 12px 32px rgba(15, 23, 42, 0.08)',
  },
  footerActions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
});

class DettaglioSchedaNuovoManuale extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      columns2: [],
      records2: [],
      schedaData: [],
      cadenzeDisponibili: [
        'GIORNALIERA',
        'SETTIMANALE',
        'MENSILE',
        'ANNUALE',
        'ALTRO',
      ],
      immaginiProcedure: [],
      newImageFile: null,
      newPdfFile: null,
      records: [],
      isAssociazioneModalOpen: false,
      isValoreModalOpen: false,
      totalPages: 0,
      imageUploadDisabled: true,
      pdfUploadDisabled: true,
      categorieSchede: [],
      isOrarioModalOpen: false,
      currentScheda: null,
      tipologieElementi: [],
      isListaOrariDisabled: false,
      attrezzature: [],
      reparti: [],
      pageLoading: true,
      uploadingImage: false,
      locali: [],
      tipiDiColonna: [''],
      indexToChange: 0,
      edit: false,
      tableKey: 0,
    };
  }

  openSuccessDialog = (successMessage) => {
    reportError(successMessage, 'Operazione effettuata');
  };

  componentDidMount() {
    this._isMounted = true;
    window.scrollTo(0, 0);
    let a = this.generateSchedaColumns();
    let b = this.generateColumnsForColumns();
    this.setState({
      columns: a,
      columns2: b,
    });
    this.getSchede();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleSaveScheda = () => {
    let schedaData = [...this.state.schedaData];
    let recordsToSave = [...this.state.records];
    const { records2 } = this.state;
    const hasEmptyValuesForSelection = records2.some(
      (record) =>
        (record.selectedTipo === 'selezione' ||
          record.selectedTipo === 'selezione_multipla') &&
        (!record.valoriAggiunti || record.valoriAggiunti.length === 0),
    );
    if (hasEmptyValuesForSelection) {
      reportError(
        "È necessario aggiungere almeno un valore nel caso di tipo di colonna 'Scelta Multipla' o 'Scelta Singola'.",
        'Attenzione',
      );
      return;
    }
    const hasEmptyValuesForConformita = records2.some(
      (record) =>
        record.selectedTipo === 'conformita' &&
        (!record.valoriAggiunti || record.valoriAggiunti.length !== 2),
    );
    if (hasEmptyValuesForConformita) {
      reportError(
        "È necessario aggiungere due valori per colonna di tipo 'Conformità / Non Conformità'.",
        'Attenzione',
      );
      return;
    }
    const hasEmptyTitle = records2.some(
      (record) => !record.titoloColonna || record.titoloColonna.trim() === '',
    );
    if (hasEmptyTitle) {
      reportError(
        'È necessario inserire il titolo della colonna.',
        'Attenzione',
      );
      return;
    }
    // Trimmed, like the emptiness check above: the table writes whatever the
    // user typed, so two titles that only differ by surrounding spaces are
    // the same name once rendered as a column header.
    const columnTitles = records2.map((record) => record.titoloColonna.trim());
    const hasDuplicateTitle = columnTitles.some(
      (title, index) => columnTitles.indexOf(title) !== index,
    );
    if (hasDuplicateTitle) {
      reportError(
        'Attenzione, non è possibile avere due colonne con lo stesso nome',
        'Attenzione',
      );
      return;
    }

    if (recordsToSave[0].selectedCadenza === 'NoChoice') {
      schedaData[0].cadenza = null;
    } else {
      schedaData[0].cadenza = recordsToSave[0].selectedCadenza;
    }
    schedaData[0].categoria = recordsToSave[0].selectedCategoria;
    schedaData[0].calendarizzato = recordsToSave[0].isCalendarizzata;
    schedaData[0].cadenze = recordsToSave[0].cadenze;
    schedaData[0].periodico = recordsToSave[0].periodico;
    // Every save carries the default reparti on top of the chosen ones. This
    // has to be a new array - recordsToSave[0].reparti is the associazione
    // modal's state, and each Salva would add another copy to it - and the
    // Set keeps a default the user also picked by hand from being sent twice.
    const repartiDefault = this.state.reparti
      .filter((reparto) => reparto.repartoDefault)
      .map((reparto) => reparto.id);
    schedaData[0].reparti = [
      ...new Set([...recordsToSave[0].reparti, ...repartiDefault]),
    ];
    // Refused instead of sent: the backend rejects a calendarizzata scheda
    // with no cadenze, so the round trip can only end in an error. A scheda
    // periodica is exempt - its single cadenza is generated further down,
    // so it legitimately has none at this point.
    if (
      schedaData[0].calendarizzato &&
      schedaData[0].cadenza !== null &&
      schedaData[0].cadenze.length === 0 &&
      schedaData[0].periodico !== true
    ) {
      reportError(
        "Una volta scelta una tipologia di cadenza, bisogna associare delle cadenze nell'apposita tabella",
        'Attenzione',
      );
      return;
    }
    if (schedaData[0].periodico === true) {
      schedaData[0].cadenze = [];
      let record = {};
      if (schedaData[0].cadenza === 'GIORNALIERA') {
        record.orario = '08:00:00';
        record.giornoSettimana = null;
        record.mese = null;
        record.giornoMese = null;
        record.schedaId = null;
        record.controlloConformitaId = null;
        record.id = null;
        record.schedaId = schedaData[0].id;
      } else if (schedaData[0].cadenza === 'SETTIMANALE') {
        record.orario = '08:00:00';
        record.giornoSettimana = 'MONDAY';
        record.mese = null;
        record.giornoMese = null;
        record.schedaId = null;
        record.controlloConformitaId = schedaData[0].id;
        record.id = null;
        record.schedaId = schedaData[0].id;
      } else if (schedaData[0].cadenza === 'MENSILE') {
        record.orario = '08:00:00';
        record.giornoSettimana = null;
        record.mese = null;
        record.giornoMese = 1;
        record.schedaId = null;
        record.controlloConformitaId = schedaData[0].id;
        record.id = null;
        record.schedaId = schedaData[0].id;
      } else if (schedaData[0].cadenza === 'ANNUALE') {
        record.orario = '08:00:00';
        record.giornoSettimana = null;
        record.mese = 'JANUARY';
        record.giornoMese = 1;
        record.schedaId = null;
        record.controlloConformitaId = schedaData[0].id;
        record.id = null;
        record.schedaId = schedaData[0].id;
      }
      schedaData[0].cadenze.push(record);
    }
    let schedaColumnsData = [...this.state.records2];
    let arrayOfTitles = [];
    let arrayOfColumns = [];
    schedaColumnsData.forEach((item, index) => {
      arrayOfTitles.push(item.titoloColonna);

      let newObject = {
        nomeColonna: item.titoloColonna,
        tipo: item.selectedTipo,
        opzioni:
          item.selectedTipo === 'selezione' ||
          item.selectedTipo === 'conformita' ||
          item.selectedTipo === 'selezione_multipla'
            ? item.valoriAggiunti
            : null,
      };
      arrayOfColumns.push(newObject);
    });
    schedaData[0].colonne = JSON.stringify(arrayOfTitles);
    schedaData[0].definizioniColonne = JSON.stringify(arrayOfColumns);
    putModificaScheda(schedaData[0])
      .then((response) => {
        this.getSchede();
        this.openSuccessDialog('Elemento salvato con successo');
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  handleSaveColumn = (data) => {
    const updatedRecords2 = this.state.records2.map((record, index) =>
      index === this.state.indexToChange
        ? { ...record, valoriAggiunti: data }
        : record,
    );
    this.setState({
      records2: updatedRecords2,
      isValoreModalOpen: false,
      edit: true,
    });
  };

  populateSchedaTable = () => {
    let arrayOfSchede = [...this.state.schedaData];
    if (arrayOfSchede.length > 0) {
      if (arrayOfSchede[0].periodico === true) {
        this.setState({
          isListaOrariDisabled: true,
        });
      }
      let records = [];
      let cadenzaToAssign = arrayOfSchede[0].cadenza;
      if (arrayOfSchede[0].cadenza === null) {
        cadenzaToAssign = 'NoChoice';
      }
      let newRecord = {
        selectedCategoria: arrayOfSchede[0].categoria,
        isCalendarizzata: arrayOfSchede[0].calendarizzato,
        selectedCadenza: cadenzaToAssign,
        cadenze: arrayOfSchede[0].cadenze,
        reparti: arrayOfSchede[0].reparti,
        periodico: arrayOfSchede[0].periodico,
      };
      records.push(newRecord);
      this.setState({
        records: records,
        pageLoading: false,
      });

      let parsedData = JSON.parse(arrayOfSchede[0].definizioniColonne);
      let arrayOfRecords = [];
      parsedData.forEach((item) => {
        let newRecord2 = {
          selectedTipo: item.tipo,
          titoloColonna: item.nomeColonna,
          valoriAggiunti: item.opzioni,
        };
        arrayOfRecords.push(newRecord2);
      });
      this.setState({
        records2: arrayOfRecords,
      });
    }
  };

  openAssociazioneModal = (indexToChange) => {
    this.setState({
      isAssociazioneModalOpen: true,
      indexToChange: indexToChange,
    });
  };

  closeAssociazioneModal = () => {
    this.setState({
      isAssociazioneModalOpen: false,
    });
  };

  closeOrarioModal = () => {
    this.setState({
      isOrarioModalOpen: false,
    });
  };

  openOrarioModal = (cadenza, scheda, index) => {
    this.setState({
      isOrarioModalOpen: true,
      orarioMode: 'Normal',
      currentScheda: scheda,
      cadenzaPassata: cadenza,
      indexToChange: index,
    });
  };

  openNewValueModal = (index) => {
    this.setState({
      isValoreModalOpen: true,
      indexToChange: index,
    });
  };

  closeNewValueModal = (index) => {
    this.setState({
      isValoreModalOpen: false,
      indexToChange: index,
    });
  };

  setCadenzeToControllo = (cadenze) => {
    let arrayOfControlli = [...this.state.records];
    let schedaDataToChange = [...this.state.schedaData];
    schedaDataToChange[0].cadenze = cadenze;
    arrayOfControlli[this.state.indexToChange].cadenze = cadenze;
    this.setState({
      records: arrayOfControlli,
      schedaData: schedaDataToChange,
      isOrarioModalOpen: false,
    });
  };

  getSchede = () => {
    getSchedeTramiteId(this.props.id)
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            schedaData: [response],
            edit: false,
            immaginiProcedure: response.immagini,
          });
        }
        return getCategorieSchede();
      })
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            categorieSchede: response,
          });
        }
        return getTipologiaStrumentazione(
          this.props.idManuale,
          0,
          1000,
          'nome,ASC',
        );
      })
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            tipologieElementi: response,
          });
        }
        return getAttrezzatureWithOnlyManualeId(
          this.props.idManuale,
          0,
          10000,
          'indiceOrdinamento,ASC',
        );
      })
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            attrezzature: response,
          });
        }

        return getLocaliManuale(this.props.idManuale, 0, 1000, 'nome,ASC');
      })
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            locali: response,
          });
        }
        return getReparti(this.props.idManuale, 0, 1000, 'nome,asc');
      })
      .then((response) => {
        if (this._isMounted) {
          this.setState(
            {
              reparti: response,
            },
            () => this.populateSchedaTable(),
          );
        }
      })

      .catch((error) => {
        reportApiError(error);
      });
  };

  handleNewRow = () => {
    let arrayOfRecord2 = [...this.state.records2];
    if (arrayOfRecord2.length < 20) {
      let newRecord2 = {
        selectedTipo: 'testo_libero',
        titoloColonna: '',
        valoriAggiunti: [],
      };
      arrayOfRecord2.push(newRecord2);
      this.setState(
        {
          records2: arrayOfRecord2,
        },
        () => {},
      );
    } else {
      alert('Attenzione, non si possono aggiungere più di 20 colonne');
    }
  };

  deleteRow = (cellInfo) => {
    let arrayOfRecord2 = [...this.state.records2];
    arrayOfRecord2.splice(cellInfo._index, 1);
    this.setState({
      records2: arrayOfRecord2,
    });
    this.setState((prevState) => ({ tableKey: prevState.tableKey + 1 }));
  };

  addAttrezzatureOrRepartiToControllo = (recordsToAdd) => {
    let arrayOfRepartiToAssociate = [];
    recordsToAdd.forEach((item) => {
      if (item.checked) {
        arrayOfRepartiToAssociate.push(item.idReparto);
      }
    });
    const updatedRecords = this.state.records.map((record, index) =>
      index === this.state.indexToChange
        ? { ...record, reparti: arrayOfRepartiToAssociate }
        : record,
    );
    const updatedSchedaData = this.state.schedaData.map((scheda, index) =>
      index === 0 ? { ...scheda, reparti: arrayOfRepartiToAssociate } : scheda,
    );
    this.setState({
      records: updatedRecords,
      schedaData: updatedSchedaData,
      edit: true,
      isAssociazioneModalOpen: false,
    });
  };

  uploadImage = (file) => {
    this.setState({
      uploadingImage: true,
      imageUploadDisabled: true,
    });
    uploadSchedaImage(file)
      .then((result) => {
        let id = result;
        this.confirmImageRegistration(id);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          uploadingImage: false,
        });
        reportApiError(error);
      });
  };

  uploadPdf = () => {
    const { newPdfFile } = this.state;
    const formData = new FormData();
    formData.append('file', newPdfFile);

    this.setState({
      uploadingImage: true,
      pdfUploadDisabled: true,
    });

    postAggiuntaPDFForParagrafo(formData)
      .then((response) => {
        this.confirmPdfRegistration(response.id);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          uploadingImage: false,
        });
        reportApiError(error);
      });
  };

  addImage = (id, index) => {
    let image = {
      id: id,
      titolo: '',
      note: '',
      posizione: index,
    };
    return image;
  };

  confirmImageRegistration = (id) => {
    let procedura = [...this.state.schedaData];
    let immaginiProcedure = [...this.state.immaginiProcedure];
    immaginiProcedure.push(this.addImage(id, immaginiProcedure.length));
    procedura[0].immagini = immaginiProcedure;
    this.setState({
      newImageFile: null,
      immaginiProcedure: immaginiProcedure,
      schedaData: procedura,
      uploadingImage: false,
      edit: true,
    });
  };

  handleImageFileSelection = (event) => {
    const imageFile = event.target.files[0];

    if (imageFile.type !== 'image/png') {
      reportError(
        'Attenzione, possono essere caricate solo immagini in formato PNG.',
      );
      return;
    }
    if (imageFile.size > 500000) {
      reportError(
        "Attenzione, la dimensione dell'immagine caricata è maggiore 500kB.",
      );
      return;
    }

    this.setState({
      newImageFile: imageFile,
      imageUploadDisabled: false,
    });
  };

  handlePdfFileSelection = (event) => {
    const pdfFile = event.target.files[0];

    if (!pdfFile) return;

    if (pdfFile.type !== 'application/pdf') {
      reportError(
        'Attenzione, possono essere caricati solo documenti in formato PDF.',
      );
      return;
    }

    if (pdfFile.size > 10000000) {
      reportError(
        'Attenzione, la dimensione del documento caricato è maggiore di 10MB.',
      );
      return;
    }

    this.setState({
      newPdfFile: pdfFile,
      pdfUploadDisabled: false,
    });
  };

  confirmPdfRegistration = (pdfId) => {
    const { newPdfFile, schedaData, immaginiProcedure } = this.state;
    const newPdfObject = {
      id: pdfId,
      note: null,
      posizione: immaginiProcedure.length,
      titolo: newPdfFile.name,
      type: 'PDF',
    };

    const updatedImmaginiProcedure = [...immaginiProcedure, newPdfObject];
    const updatedSchedaData = [
      { ...schedaData[0], immagini: updatedImmaginiProcedure },
    ];

    this.setState({
      newPdfFile: null,
      immaginiProcedure: updatedImmaginiProcedure,
      schedaData: updatedSchedaData,
      pdfUploadDisabled: true,
      uploadingImage: false,
      edit: true,
    });
  };

  deleteAttachment = (id) => {
    let immaginiProcedure = this.state.immaginiProcedure;
    let newarray = immaginiProcedure.filter((item) => item.id !== id);
    let procedura = [...this.state.schedaData];
    procedura[0].immagini = newarray;
    newarray.forEach((a, index) => (a.posizione = index));
    this.setState({
      immaginiProcedure: newarray,
      schedaData: procedura,
      changesNotSaved: true,
      disableSubmitButton: false,
      notSaved: true,
    });
  };

  changeImageField = (value, index, field) => {
    let immaginiProcedure = this.state.immaginiProcedure;
    immaginiProcedure[index][field] = value;

    this.setState({
      immaginiProcedure,
      notSaved: true,
    });
  };

  moveComponent = (fromIndex, toIndex) => {
    this.setState((prevState) => {
      const immaginiProcedure = [...prevState.immaginiProcedure];

      if (
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= immaginiProcedure.length ||
        toIndex >= immaginiProcedure.length
      ) {
        reportError('Indici non validi per lo spostamento degli allegati.');
        return;
      }

      const [element] = immaginiProcedure.splice(fromIndex, 1); // Remove elemnent
      immaginiProcedure.splice(toIndex, 0, element); // Insert element at new index
      immaginiProcedure.forEach((a, index) => (a.posizione = index)); // Update position for each element

      return {
        immaginiProcedure,
        notSaved: true,
      };
    });
  };

  handlePdfView = (pdfId) => {
    if (!pdfId) {
      reportError('ID PDF mancante. Non è possibile recuperare il documento.');
      return;
    }

    getPDFForParagrafo(pdfId)
      .then((response) => {
        if (response?.url) {
          window.open(response.url, '_blank');
        } else {
          reportError('URL PDF non disponibile.');
        }
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  handleChangeSchedaField = (event, field) => {
    const { value } = event.target;
    this.setState((prevState) => {
      const updatedSchedaData = [...prevState.schedaData];
      updatedSchedaData[0] = {
        ...updatedSchedaData[0],
        [field]: value,
      };

      return {
        schedaData: updatedSchedaData,
        notSaved: true,
      };
    });
  };

  generateSchedaColumns = () => {
    return [
      {
        Header: 'Categoria Scheda',
        id: 'CategoriaScheda',
        width: 320,
        accessor: (d) => d.selectedCategoria,
        Cell: (props) => (
          <Select
            style={{ marginTop: 10, width: '100%' }}
            onChange={(event) => {
              let arrayOfRecords = [...this.state.records];
              arrayOfRecords[0].selectedCategoria = event.target.value;
              this.setState({
                records: arrayOfRecords,
                edit: true,
              });
            }}
            value={props.row.CategoriaScheda}
          >
            {this.state.categorieSchede
              .filter((category) => category.value !== 'PERSONALIZZATA')
              .map((category) => {
                return (
                  <MenuItem key={category.value} value={category.value}>
                    {category.label}
                  </MenuItem>
                );
              })}
          </Select>
        ),
      },
      {
        Header: 'Scheda Calendarizzata',
        id: 'schedaCalendarizzata',
        width: 200,
        accessor: (d) => d.isCalendarizzata,
        Cell: (props) => (
          <Select
            onChange={(event) => {
              let arrayOfRecords = [...this.state.records];
              arrayOfRecords[0].isCalendarizzata = event.target.value;
              if (event.target.value === true) {
                arrayOfRecords[0].selectedCadenza = 'GIORNALIERA';
                arrayOfRecords[0].cadenze = [];
                this.setState({
                  isListaOrariDisabled: false,
                });
              } else {
                arrayOfRecords[0].selectedCadenza = 'NoChoice';
                arrayOfRecords[0].cadenze = [];
                arrayOfRecords[0].periodico = false;
                this.setState({
                  isListaOrariDisabled: true,
                });
              }
              this.setState({
                records: arrayOfRecords,
                edit: true,
              });
            }}
            value={props.row.schedaCalendarizzata}
            style={{ marginTop: 10, width: '100%' }}
          >
            <MenuItem key={1} value={true}>
              Si
            </MenuItem>
            <MenuItem key={2} value={false}>
              No
            </MenuItem>
          </Select>
        ),
      },
      {
        Header: 'Periodica',
        id: 'Periodica',
        width: 120,
        accessor: (d) => d.periodico,
        Cell: (props) => (
          <Checkbox
            disabled={!props.row.schedaCalendarizzata}
            value={props.row.Periodica}
            checked={props.row.Periodica}
            onChange={() => {
              let records = [...this.state.records];
              records[props.row._index].periodico =
                !records[props.row._index].periodico;
              if (records[props.row._index].periodico === true) {
                this.setState({
                  isListaOrariDisabled: true,
                });
              }
              if (records[props.row._index].periodico === false) {
                this.setState({
                  isListaOrariDisabled: false,
                });
              }
              this.setState({
                records: records,
                edit: true,
              });
            }}
          />
        ),
      },
      {
        Header: 'Cadenza',
        id: 'Cadenza',
        width: 320,
        accessor: (d) => d.selectedCadenza,
        Cell: (props) => (
          <Select
            style={{ marginTop: 10, width: '100%' }}
            onChange={(event) => {
              let arrayOfRecords = [...this.state.records];
              arrayOfRecords[0].selectedCadenza = event.target.value;
              let dataToUpdate = [...this.state.schedaData];
              dataToUpdate[0].cadenze = [];
              arrayOfRecords[0].cadenze = [];
              if (
                event.target.value === 'NoChoice' ||
                event.target.value === 0 ||
                props.row.Periodica === true
              ) {
                this.setState({
                  isListaOrariDisabled: true,
                });
              } else {
                this.setState({
                  isListaOrariDisabled: false,
                });
              }
              this.setState({
                records: arrayOfRecords,
                schedaData: dataToUpdate,
                edit: true,
              });
            }}
            value={props.row.Cadenza}
          >
            {this.state.cadenzeDisponibili.map((item, index) => {
              if (props.row.schedaCalendarizzata === true && item !== 'ALTRO') {
                return (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                );
              } else if (
                props.row.schedaCalendarizzata === false &&
                item === 'ALTRO'
              ) {
                return (
                  <MenuItem key={index} value={'NoChoice'}>
                    {etichettaCadenza(item)}
                  </MenuItem>
                );
              }
              return null;
            })}
          </Select>
        ),
      },
      {
        Header: 'Lista Orari',
        id: 'ListaOrari',
        width: 120,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            disabled={this.state.isListaOrariDisabled}
            onClick={() =>
              this.openOrarioModal(
                props.row.Cadenza,
                this.state.schedaData,
                props.row._index,
              )
            }
            style={{ marginTop: 10 }}
            size="small"
          >
            <Edit />
          </IconButton>
        ),
      },
      {
        Header: 'Associazioni',
        id: 'Associazioni',
        width: 120,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            onClick={() => this.openAssociazioneModal(props.row._index)}
            style={{ marginTop: 10 }}
            size="small"
          >
            <Edit />
          </IconButton>
        ),
      },
    ];
  };

  generateColumnsForColumns = () => {
    return [
      {
        Header: 'Tipo di Colonna',
        id: 'tipoColonna',
        width: 300,
        accessor: (d) => d,
        Cell: (props) => (
          <Select
            value={props.row.tipoColonna.selectedTipo}
            onChange={(event) => {
              this.setState((prevState) => {
                const updatedRecords = prevState.records2.map((record, i) =>
                  i === props.row._index
                    ? { ...record, selectedTipo: event.target.value }
                    : record,
                );

                return { records2: updatedRecords };
              });
            }}
            style={{ marginTop: 10, width: '100%' }}
          >
            <MenuItem value="testo_libero">Testo libero</MenuItem>
            <MenuItem value="selezione">Scelta Multipla</MenuItem>
            <MenuItem value="conformita">Conformità / Non Conformità</MenuItem>
            <MenuItem value="data">Data</MenuItem>
            <MenuItem value="selezione_multipla">Scelta Singola</MenuItem>
            <MenuItem value="numerico">Numerico</MenuItem>
          </Select>
        ),
      },
      {
        Header: 'Aggiungi Valore',
        id: 'aggiungiValore',
        width: 300,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            disabled={
              props.row.tipoColonna.selectedTipo !== 'selezione' &&
              props.row.tipoColonna.selectedTipo !== 'conformita' &&
              props.row.tipoColonna.selectedTipo !== 'selezione_multipla'
            }
            size="small"
            style={{ marginTop: 10 }}
            onClick={() => this.openNewValueModal(props.row._index)}
          >
            <Edit />
          </IconButton>
        ),
      },
      {
        Header: 'Titolo Colonna',
        id: 'titoloColonna',
        width: 480,
        accessor: (d) => d.titoloColonna,
        Cell: (props) => (
          <TextField
            inputProps={{ style: { textAlign: 'center' } }}
            defaultValue={props.row.titoloColonna}
            onInput={(event) => {
              let colonneRecords = [...this.state.records2];
              colonneRecords[props.row._index].titoloColonna =
                event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records2: colonneRecords,
              });
            }}
            style={{ marginTop: 10, width: '80%' }}
          />
        ),
      },
      {
        Header: 'Elimina',
        id: 'Elimina',
        width: 120,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton onClick={() => this.deleteRow(props.row)} title="Elimina">
            <DeleteForever color="primary" />
          </IconButton>
        ),
      },
    ];
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainContainer}>
        <div className={classes.pageShell}>
          <div className={classes.pageHeader}>
            <Typography className={classes.typo} variant="h4">
              Configurazione scheda
            </Typography>
            <Typography className={classes.pageSubtitle} variant="body1">
              Aggiorna contenuti, allegati e struttura della scheda in una
              pagina più leggibile, mantenendo invariato tutto il comportamento
              operativo.
            </Typography>
          </div>

          {this.state.pageLoading ? (
            <SpinnerComponent size={32} />
          ) : (
            <>
              <div className={classes.panelCard}>
                <div className={classes.sectionHeader}>
                  <div className={classes.sectionHeading}>
                    <Typography variant="h6" className={classes.typo}>
                      Informazioni scheda
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.sectionDescription}
                    >
                      Gestisci titolo, descrizione e allegati in un&apos;unica
                      sezione.
                    </Typography>
                  </div>
                </div>
                <Container className={classes.contentContainer}>
                  <OneLineTextInputComponent
                    label={'Titolo:'}
                    fieldname={'titolo'}
                    fieldvalue={this.state.schedaData[0].titolo}
                    onChangeEvent={this.handleChangeSchedaField}
                  />
                  <MultilineTextInputComponent
                    label={'Descrizione procedura'}
                    fieldname={'descrizione'}
                    fieldvalue={this.state.schedaData[0].descrizione}
                    onChangeEvent={this.handleChangeSchedaField}
                  />
                  <div className={classes.uploadWrapper}>
                    <div className={classes.uploadContainer}>
                      <FileUploader
                        uploadDisabled={this.state.imageUploadDisabled}
                        loading={this.state.uploadingImage}
                        file={this.state.newImageFile}
                        onFileSelect={this.handleImageFileSelection}
                        onUpload={() =>
                          this.uploadImage(this.state.newImageFile)
                        }
                        accept="image/png"
                      />
                    </div>
                    <div className={classes.uploadContainer}>
                      <FileUploader
                        uploadDisabled={this.state.pdfUploadDisabled}
                        loading={this.state.uploadingImage}
                        file={this.state.newPdfFile}
                        onFileSelect={this.handlePdfFileSelection}
                        onUpload={this.uploadPdf}
                        accept="application/pdf"
                      />
                    </div>
                  </div>
                  <AttachmentList
                    loading={this.state.uploadingImage}
                    attachments={this.state.immaginiProcedure}
                    onRemoveAttachment={this.deleteAttachment}
                    onMove={this.moveComponent}
                    onChangeField={this.changeImageField}
                    urlPath="/api/schede/immagini/"
                    title="Allegati caricati"
                    emptyMessage="Nessun allegato caricato per questa scheda. Usa i riquadri sopra per caricare un'immagine PNG o un documento PDF."
                    onViewPdf={this.handlePdfView}
                  />
                </Container>
              </div>

              <div className={`${classes.panelCard} ${classes.tableWrapper}`}>
                <div className={classes.sectionHeader}>
                  <div className={classes.sectionHeading}>
                    <Typography variant="h6" className={classes.typo}>
                      Scheda
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.sectionDescription}
                    >
                      Controlla i dati principali della scheda e il loro ordine
                      di visualizzazione.
                    </Typography>
                  </div>
                </div>
                <div className={classes.tableSurface}>
                  <ReactTable
                    filterable={false}
                    resizable={true}
                    enableEditing={true}
                    showPageSizeOptions={false}
                    showPageJump={true}
                    defaultPageSize={1}
                    style={{
                      height: 130,
                      minWidth: 760,
                    }}
                    pages={this.state.totalPages}
                    data={this.state.records}
                    columns={this.state.columns}
                    previousText="Precedente"
                    nextText="Successivo"
                    noDataText="Nessun record"
                    pageText="Pagina"
                    ofText="di"
                    rowsText="righe"
                    pageJumpText="Vai a pagina"
                    rowsSelectorText="righe per pagina"
                    getTrProps={(state, rowInfo) => {
                      if (!rowInfo) return {};

                      return {
                        key: rowInfo.original.id || rowInfo.index,
                      };
                    }}
                  />
                </div>
              </div>

              <div className={`${classes.panelCard} ${classes.tableWrapper}`}>
                <div className={classes.sectionHeader}>
                  <div className={classes.sectionHeading}>
                    <Typography variant="h6" className={classes.typo}>
                      Colonne
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.sectionDescription}
                    >
                      Aggiungi e configura le colonne della scheda mantenendo
                      più leggibile la gerarchia delle azioni.
                    </Typography>
                  </div>
                  <Button
                    color="primary"
                    variant="outlined"
                    className={classes.secondaryActionButton}
                    onClick={this.handleNewRow}
                  >
                    Aggiungi colonna
                  </Button>
                </div>
                <div className={classes.tableSurface}>
                  <ReactTable
                    key={this.state.tableKey}
                    sortable={false}
                    filterable={false}
                    resizable={true}
                    enableEditing={true}
                    showPageSizeOptions={false}
                    showPageJump={true}
                    defaultPageSize={20}
                    style={{
                      height: 400,
                      minWidth: 960,
                    }}
                    pages={this.state.totalPages}
                    data={this.state.records2}
                    columns={this.state.columns2}
                    previousText="Precedente"
                    nextText="Successivo"
                    noDataText="Nessun record"
                    pageText="Pagina"
                    ofText="di"
                    rowsText="righe"
                    pageJumpText="Vai a pagina"
                    rowsSelectorText="righe per pagina"
                    getTrProps={(state, rowInfo) => {
                      if (!rowInfo) return {};

                      return {
                        key: rowInfo.original.id || rowInfo.index,
                      };
                    }}
                  />
                </div>
              </div>

              <div className={classes.footerBar}>
                <div className={classes.footerActions}>
                  <IndietroButtonColorFul
                    secondaryButton
                    alert={this.state.edit}
                    isDisabled={false}
                  />
                  <ActionButton
                    label="Salva"
                    disabled={false}
                    grayVersion={false}
                    onClick={this.handleSaveScheda}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        {this.state.isAssociazioneModalOpen && (
          <ModalSelezioneAssociazioneScheda
            open={this.state.isAssociazioneModalOpen}
            onClose={this.closeAssociazioneModal}
            mode={this.state.associazioneMode}
            reparti={this.state.reparti}
            schedaData={this.state.schedaData}
            saveValues={this.addAttrezzatureOrRepartiToControllo}
            indexToChange={this.state.indexToChange}
          />
        )}
        {this.state.isOrarioModalOpen && (
          <ModalSelezioneOrarioScheda
            theme={this.props.theme}
            open={this.state.isOrarioModalOpen}
            onClose={this.closeOrarioModal}
            mode={this.state.orarioMode}
            addCadenza={this.handleCadenza}
            cadenza={this.state.cadenzaPassata}
            cadenze={this.state.schedaData[0].cadenze}
            indexToUpdate={this.state.indexToChange}
            setCadenzeToControllo={this.setCadenzeToControllo}
            scheda={this.state.currentScheda}
            categorieSchede={this.state.categorieSchede}
            schedaId={this.state.schedaData[0].id}
          />
        )}
        {this.state.isValoreModalOpen && (
          <ModalAggiuntaValori
            open={this.state.isValoreModalOpen}
            onClose={() => this.closeNewValueModal(this.state.indexToChange)}
            columnData={this.state.records2}
            selectedIndex={this.state.indexToChange}
            saveColumnData={this.handleSaveColumn}
          />
        )}
      </div>
    );
  }
}

DettaglioSchedaNuovoManuale.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  idManuale: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles)(DettaglioSchedaNuovoManuale);
